import { createStore } from '@aibees/shared/store';
import { InsufficientCreditStoreData as StoreData } from './types';

const useInsufficientCreditStore = createStore<StoreData>(
  'insufficient-credit',
  (set) => ({
    isError: false,
    setIsError: (isError) => set({ isError }),
  })
);

export default useInsufficientCreditStore;
